module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.5535/img/video-thumb-overlay.png"